import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  Chip,
  Grid2 as Grid,
  Skeleton,
  Stack,
} from "@mui/material";

const CARD_HEIGHT = 125;

function MailListCardCompactSkeleton() {
  return (
    <Card
      sx={{
        width: "100%",
        height: CARD_HEIGHT,
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          flex: 1,
          p: 2,
          display: "flex",
          flexDirection: "column",
          minWidth: 0,
        }}
      >
        {/* Title row */}
        <Stack direction="row" gap={1} alignItems="center">
          <Skeleton variant="text" width={160} height={28} />
        </Stack>

        {/* Email */}
        <Skeleton variant="text" width="70%" height={22} />

        {/* Description */}
        <Skeleton variant="text" width="50%" height={20} />

        {/* Member pill */}
        <Skeleton
          variant="rounded"
          width={90}
          height={24}
          sx={{ alignSelf: "flex-end", borderRadius: 27, mt: "auto" }}
        />
      </Box>
    </Card>
  );
}

interface MailListAccordionSkeletonProps {
  /** Number of accordion groups to render */
  groups?: number;
  /** Number of cards per group */
  cardsPerGroup?: number;
}

export default function MailListAccordionSkeleton({
  groups = 3,
  cardsPerGroup = 6,
}: MailListAccordionSkeletonProps) {
  return (
    <Stack spacing={3}>
      {Array.from({ length: groups }).map((_, groupIndex) => (
        <Accordion
          key={groupIndex}
          sx={{
            boxShadow: 0,
            border: "none",
            "&::before": { display: "none" },
          }}
          defaultExpanded
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{
              borderLeft: 10,
              borderColor: "glyph.dark",
            }}
          >
            <Stack direction="row" alignItems="center" gap={2}>
              <Skeleton variant="text" width={140} height={36} />
              <Chip
                label={<Skeleton variant="text" width={50} />}
                color="glyph"
                sx={{
                  fontSize: 16,
                }}
              />
            </Stack>
          </AccordionSummary>
          <AccordionDetails sx={{ p: 4 }}>
            <Grid container spacing={2}>
              {Array.from({ length: cardsPerGroup }).map((_, cardIndex) => (
                <Grid key={cardIndex} size={{ xs: 12, md: 6, lg: 4 }}>
                  <MailListCardCompactSkeleton />
                </Grid>
              ))}
            </Grid>
          </AccordionDetails>
        </Accordion>
      ))}
    </Stack>
  );
}
